import Vue from "vue";
import Router from "vue-router";

// eslint-disable-next-line no-unused-vars
import {
  TokenStorage,
  FeatureStorage,
  CommonStorage,
} from "../_services/storage";

import FinanceRoute from "./finance";
import CallSchedulesRoute from "./call-schedule";
import CustomerRoute from "./customer";
import SupplierRoute from "./supplier";
import ProductRoute from "./product";
import SalesRoute from "./sales/sales";
import PurchaseRoute from "./purchase";
import InventoryRoute from "./inventory";
import SettingsRoute from "./settings";
import ReportRoute from "./reports";
import RoamRoute from "./roam";
import TouchRoute from "./touch";
import ProductionRoute from "./production";
import SampleRequest from "./sales/sample-request";
import PointOfSale from "./sales/point-of-sale";

Vue.use(Router);

// Lazy load function
const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/${file}.vue`);

const router = new Router({
  mode: "history",
  routes: [
    ...FinanceRoute,
    ...CallSchedulesRoute,
    ...CustomerRoute,
    ...SupplierRoute,
    ...ProductRoute,
    ...SalesRoute,
    ...PurchaseRoute,
    ...InventoryRoute,
    ...SettingsRoute,
    ...ReportRoute,
    ...RoamRoute,
    ...TouchRoute,
    ...ProductionRoute,
    ...SampleRequest,
    ...PointOfSale,
    {
      path: "/login-form",
      name: "login-form",
      meta: { requiresAuth: false },
      components: {
        // route level code-splitting
        // this generates a separate chunk (login.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        content: lazyLoad("login-form"),
      },
    },
    {
      path: "/",
      redirect: "/home",
      meta: { requiresAuth: true },
    },
    {
      path: "/home",
      name: "home",
      meta: { requiresAuth: true },
      components: {
        content: lazyLoad("home"),
      },
    },
    {
      path: "/help",
      name: "help",
      meta: { requiresAuth: true },
      components: {
        content: lazyLoad("help"),
      },
    },
    {
      path: "/unauthorized",
      name: "unauthorized",
      meta: { requiresAuth: true },
      components: {
        content: lazyLoad("unauthorized"),
      },
    },
    {
      path: "*",
      name: "pageNotFound",
      meta: { requiresAuth: true },
      components: {
        content: lazyLoad("page-not-found"),
      },
    },
    {
      path: "/redirect",
      name: "redirect",
      meta: { requiresAuth: true },
      components: {
        content: lazyLoad("redirect"),
      },
    },
  ],
});

// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
  document.title = "GCORPcx";
  Vue.prototype.$logger.trackEventOpenScreen(to.name);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const redirect = urlParams.get("redirect");

  const loggedIn = !!TokenStorage.getToken();
  if (to.name === "login-form" && loggedIn) {
    if (redirect) {
      next({ path: redirect });
    } else next({ name: "home" });
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!loggedIn) {
      var query = {};
      if (CommonStorage.getItems("APP_SESSION_TIME_OUT")) {
        query.s_out = CommonStorage.getItems("APP_SESSION_TIME_OUT");
        query.redirect = to.fullPath;
      }

      if (CommonStorage.getItems("APP_VERSION_CHECK")) {
        query.redirect = to.fullPath;
      }

      next({
        name: "login-form",
        query: query,
      });
    } else {
      // eslint-disable-next-line no-console
      // this.$logger.debug(
      //   "to.meta.applicationFeatureCode",
      //   to.meta.applicationFeatureCode
      // );
      if (
        !!to.meta.applicationFeatureCode &&
        !FeatureStorage.checkPermission(
          to.meta.applicationFeatureCode,
          "review"
        )
      ) {
        return next({
          path: "/unauthorized",
        });
      }
      CommonStorage.saveItems("currentRoute", to.fullPath);
      next();
    }
  } else {
    CommonStorage.saveItems("currentRoute", to.fullPath);
    next();
  }
});

export default router;
